import { useWallet } from 'components/WalletContext';
import { useMemo } from 'react';
import { ebChainId } from 'utils/config';

const useLegacyIsRightNetwork = () => {
  const { network } = useWallet();

  return useMemo(() => network === ebChainId, [network]);
};

export default useLegacyIsRightNetwork;
